export function getSaasEnabled(): boolean {
  try {
    return __ENABLE_SAAS__;
  } catch (err) {
    return false;
  }
}
